import { render, staticRenderFns } from "./script_create.vue?vue&type=template&id=34825756"
import script from "./script_create.vue?vue&type=script&lang=js"
export * from "./script_create.vue?vue&type=script&lang=js"
import style0 from "./script_create.vue?vue&type=style&index=0&id=34825756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports